<template>
  <div class="pa-md-4">
    <v-tabs v-model="tabs" grow>
      <v-tab>
        <v-icon right>mdi-text</v-icon>
        لیست
      </v-tab>
      <v-tab>
        <v-icon right>mdi-plus</v-icon>
        افزودن
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <vue-table
          :data="data"
          :headers="headers"
          :loading.sync="loading"
          @change="onPagination"
        >
          <template v-slot:index="{ item }">
            {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
          </template>

          <template v-slot:created_at="{ item }">
            {{ item.created_at | longDate }}
          </template>

          <template v-slot:updated_at="{ item }">
            {{ item.updated_at | longDate }}
          </template>

          <template v-slot:action="{ item }">
            <div class="d-flex align-center justify-center" style="gap: 8px">
              <v-btn
                class="btn-delete btn ma-0"
                fab
                outlined
                small
                @click="removeItem(item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>

              <v-btn
                :to="`/admin/user-guide/${item.id}`"
                class="rounded-lg btn btn-edit ma-0"
                fab
                outlined
                small
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </div>
          </template>
        </vue-table>
      </v-tab-item>

      <v-tab-item>
        <add-new-user-guide
          @fetch="
            () => {
              fetch({ ...tableProps, page: 1 });
              tabs = 0;
            }
          "
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AddNewUserGuide from "@/view/content/addNewUserGuide.vue";

export default {
  name: "userGuideStore",
  components: { AddNewUserGuide },

  data: () => ({
    data: {},
    headers: [
      { value: "index", text: "ردیف", align: "center", sortable: false },
      { value: "id", text: "شناسه", align: "center", sortable: false },
      { value: "title", text: "عنوان", align: "center", sortable: false },
      { value: "service_id", text: "سرویس", align: "center", sortable: false },
      {
        value: "category_id",
        text: "دسته‌بندی",
        align: "center",
        sortable: false,
      },
      { value: "name", text: "نام یکتا", align: "center", sortable: false },
      {
        value: "created_at",
        text: "زمان ساخت",
        align: "center",
        sortable: false,
      },
      {
        value: "updated_at",
        text: "زمان ویرایش",
        align: "center",
        sortable: false,
      },
      { value: "action", text: "مدیریت", align: "center", sortable: false },
    ],
    tabs: 0,
    tableProps: {
      search: "",
      page: 1,
      length: 10,
      dir: "desc",
      column: "id",
    },
    loading: false,
  }),

  mounted() {
    this.fetch();
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true;

      this.requestApiGet("guideContent", params)
        .then(({ data }) => {
          this.data = data.data;
        })
        .catch(({ response }) => {
          this.$toast.error(response?.data?.message);
          console.log("failed to get guide content: ", response);
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.fetch(props);
    },
    async removeItem(item) {
      if (await this.$modal.yesNo("حذف آموزش؟")) {
        this.loading = true;

        this.requestApiDelete(`guideContent/delete/${item.id}`)
          .then(({ data }) => {
            this.$toast.success("با موفقیت حذف شد!");
            this.fetch({
              ...this.tableProps,
              page: 1,
            });
          })
          .catch(({ response }) => {
            console.log("failed to delete guide content: ", response);
            this.$toast.error(response?.data?.message || "خطا در حذف آموزش!");
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>

<style scoped></style>
